import { useEffect, useRef } from 'react';
// eslint-disable-next-line jira/restricted/lottie
import Lottie from 'lottie-web';

export const useLottieRef = (animationData: unknown) => {
	const lottieRef = useRef<null | HTMLDivElement>(null);

	useEffect(() => {
		if (lottieRef.current !== null) {
			Lottie.loadAnimation({
				container: lottieRef.current,
				renderer: 'svg',
				loop: true,
				autoplay: true,
				animationData,
			});
		}
	}, [animationData]);

	return { lottieRef };
};
